module.exports = __webpack_public_path__ + "static/media/400108_02.9f832526.png";